import React, { useEffect, useState } from 'react';
import {
	Box,
	Button,
	TextField,
	Typography,
	InputAdornment,
} from '@mui/material';
import Modal from './Modals/Modal';

const DepositPaidAmountDialog = ({
	open,
	defaultAmount,
	onConfirm,
	onCancel,
}) => {
	const [amount, setAmount] = useState('');

	useEffect(() => {
		if (!open) return;
		const initial =
			defaultAmount != null && Number(defaultAmount) > 0
				? Number(defaultAmount).toFixed(2)
				: '';
		setAmount(initial);
	}, [open, defaultAmount]);

	const handleConfirm = () => {
		const parsed = parseFloat(amount);
		if (Number.isNaN(parsed) || parsed <= 0) {
			return;
		}
		onConfirm(Number(parsed.toFixed(2)));
	};

	return (
		<Modal
			open={open}
			onClose={onCancel}
			modalTitle="Record deposit received"
			maxWidth="xs"
			alwaysMaxWidth
			useActionButtons
			actionButtons={
				<Box sx={{ display: 'flex', gap: 1 }}>
					<Button onClick={onCancel}>Cancel</Button>
					<Button variant="contained" onClick={handleConfirm}>
						Save
					</Button>
				</Box>
			}
		>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				Enter the deposit amount the customer actually paid. This is added to
				the deposit total tracked on the job.
			</Typography>
			<TextField
				label="Deposit amount received"
				type="number"
				fullWidth
				autoFocus
				value={amount}
				onChange={(e) => setAmount(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
						handleConfirm();
					}
				}}
				slotProps={{
					input: {
						startAdornment: <InputAdornment position="start">$</InputAdornment>,
						inputProps: { min: 0.01, step: 0.01 },
					},
				}}
			/>
		</Modal>
	);
};

export default DepositPaidAmountDialog;
